<h1 class="settings-title">Configure Settings</h1>

@if (isLoadingConfig) {
  <!-- Zoom card skeleton -->
  <div class="skeleton-card">
    <div class="skeleton-row">
      <div class="skeleton skeleton-icon"></div>
      <div class="skeleton-text-group">
        <div class="skeleton skeleton-title"></div>
        <div class="skeleton skeleton-subtitle"></div>
      </div>
      <div class="skeleton skeleton-button"></div>
    </div>
    <div class="skeleton skeleton-wide-button"></div>
  </div>

  <!-- AI model card skeleton -->
  <div class="skeleton-card">
    <div class="skeleton skeleton-label"></div>
    <div class="skeleton skeleton-desc"></div>
    <div class="skeleton-model-row">
      <div class="skeleton skeleton-model-card"></div>
      <div class="skeleton skeleton-model-card"></div>
      <div class="skeleton skeleton-model-card"></div>
    </div>
  </div>

  <!-- Timezone card skeleton -->
  <div class="skeleton-card">
    <div class="skeleton skeleton-label"></div>
    <div class="skeleton skeleton-desc"></div>
    <div class="skeleton skeleton-input"></div>
  </div>

} @else {
  <edu-zoom-integration    [orgId]="orgId" [systemConfig]="systemConfig" />
  <edu-calendar-integration />
  <edu-ai-settings         [orgId]="orgId" [systemConfig]="systemConfig" />
  <edu-timezone-settings   [orgId]="orgId" [systemConfig]="systemConfig" />
  <edu-notification-settings [orgId]="orgId" [systemConfig]="systemConfig" />
  <edu-group-visibility-settings [orgId]="orgId" [systemConfig]="systemConfig" />
  <edu-supervisor-cards-settings [orgId]="orgId" [systemConfig]="systemConfig" />
  <edu-welcome-video-settings [orgId]="orgId" />
}